import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

import { useAuthState } from '@hooks/useAuthState';
import { FCMInitializer } from '@components/FCMInitializer';
import { ThemeProvider } from './shared/contexts/ThemeContext';
import { AppRoutes } from './routes/AppRoutes';

// Create a client for React Query
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes default
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

/**
 * Root App component
 * Sets up React Query provider, Firebase auth state, and renders main routes
 */
function AppContent(): JSX.Element {
  // Sync Firebase auth state with Zustand store
  useAuthState();

  return (
    <>
      <FCMInitializer />
      <AppRoutes />
    </>
  );
}

export function App(): JSX.Element {
  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider>
        <AppContent />
      </ThemeProvider>
    </QueryClientProvider>
  );
}

